import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { ProductType } from '@xing-com/crate-common-graphql-types';
import type { Contract } from '@xing-com/crate-upsell-utils';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  spaceS,
  xdlColorPremium,
  xdlColorText,
  xdlColorBackground,
  cornerRadiusL,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export interface OfferBoxPickerProps {
  product: ProductType;
  contracts: Contract[];
  activeContractId: string;
  onContractChange: (id: string) => void;
  className?: string;
}

export const OfferBoxPicker: React.FC<OfferBoxPickerProps> = (props) => {
  const {
    contracts,
    activeContractId,
    onContractChange,
    product,
    className = '',
  } = props;

  return (
    <OfferBoxPickerWrapper data-testid="contract-picker" className={className}>
      {contracts.map(({ id, initialDuration: duration }) => (
        <ContractBox
          product={product}
          key={id}
          active={id === activeContractId}
          onClick={() => onContractChange(id)}
        >
          <BodyCopy size="large" noMargin>
            {duration}
          </BodyCopy>
          <BodyCopy size="xsmall" lineHeight="dense" noMargin>
            <FormattedMessage id="UPSELL_PURCHASE_OFFER_BOX_PICKER" />
          </BodyCopy>
        </ContractBox>
      ))}
    </OfferBoxPickerWrapper>
  );
};

const OfferBoxPickerWrapper = styled.div`
  display: flex;
  gap: ${spaceS};
`;

const ContractBox = styled.button<{
  active: boolean;
  product: ProductType;
}>`
  cursor: pointer;
  display: inline-flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  padding: 0;
  ${({ product, active }) => css`
    color: ${product === ProductType.Premium ? xdlColorPremium : xdlColorText};
    background-color: ${xdlColorBackground};
    border-radius: ${cornerRadiusL};
    border: ${active
      ? `2px solid ${product === ProductType.Premium ? xdlColorPremium : xdlColorText};
          }`
      : 'none'};
  `}

  p {
    font-weight: ${(props) => (props.active ? 'bold' : 'normal')};
  }

  @media ${mediaConfined} {
    width: 56px;
    height: 56px;
  }
`;
